module.exports = {
  BTG: 'btg',
  JD: 'jd'
};
